import React, { FC, useCallback, useEffect, useMemo, useState } from "react";
import { Spinner, Table } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import moment from "moment";

// styles
import styles from "./DataTable.module.scss";

// icons
import PrintIcon from "@material-ui/icons/Print";

//component
import OrderStatusUpdateButton from "../orderStatusUpdateButton/OrderStatusUpdateButton";
import PaginationComponent from "../paginationComponent/PaginationComponent";
import LoadingComponent from "../../loadingComponent/LoadingComponent";

//interface
import {
  IOrderStatus,
  IPartnerOrder,
  IPartnerOrderRequestModel,
} from "../../../interfaces/order";

//api
import {
  orderListRequestModel,
  orderRequestModel,
} from "../../../api/apiRequestObjects";
import apis from "../../../api/apis";

//config
import GLOBAL_MEDIA_QUERIES from "../../../config/globalMediaQueries";
import { APIResponseType } from "../../../config/enumApiResponseTypes";
import { notifyError } from "../../../config/toastNotification";
import { useSelector } from "react-redux";
import { Button, Checkbox, FormControlLabel, Switch } from "@mui/material";
import { API_INTEGRATION_ID } from "../../../config";
import { useHistory } from "react-router-dom";

interface IProps {
  orders: IPartnerOrder[];
  filteredDateValue: Date | null;
  selectedItem: IPartnerOrder;
  posOrderStatus: IOrderStatus[];
  selectedNavItem: IOrderStatus;
  statusForBtn: IOrderStatus[];
  selectItem: (order: IPartnerOrder) => void;
  updateOrder: (
    updatedOrderStatus: IOrderStatus,
    selectedOrder: IPartnerOrder
  ) => void;
  handleBillPrinting: (
    partnerOrderId: number | undefined,
    orderReference: string | undefined
  ) => void;
}

const DataTable: FC<IProps> = ({
  orders,
  filteredDateValue,
  selectedItem,
  selectedNavItem,
  selectItem,
  posOrderStatus,
  statusForBtn,
  updateOrder,
  handleBillPrinting,
}): JSX.Element => {
  //console.log(selectedNavItem.POSStatusCode);
  // console.log(statusForBtn);
  const isTablet = useMediaQuery({ query: GLOBAL_MEDIA_QUERIES.tab });

  /*   useEffect(() => {
    const timer = setTimeout(() => {
      console.log("This will run after 1 second!");
    }, 2000);
    //return () => clearTimeout(timer);
  }, []); */

  const [count, setCount] = useState(0);
  const [paginatedOrderList, setPaginatedOrderList] = useState<IPartnerOrder[]>(
    []
  );
  const [page, setPage] = useState(1);
  const [isDataTableLoading, setIsDataTableLoading] = useState(false);

  const [selectecOrder, setSelectedOrder] = useState<IPartnerOrder[]>([]);
  //console.log(selectecOrder);
  const [selectedID, setSelectedID] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const history = useHistory();

  //get redux state
  const { user } = useSelector((state: any) => state.authentication);

  //set loaded orders to paginatedOrders
  useMemo(() => {
    setPaginatedOrderList(orders);
  }, [orders]);

  // useEffect(() => {
  //   window.alert("alert");
  // });

  //fetch OrderCountByPOSStatusKey
  useEffect(() => {
    const fetchOrderCountData = async () => {
      try {
        orderRequestModel.UID.UserKey = user.UserKey;
        orderRequestModel.UID.LocationKey = user.LocationKey;
        orderRequestModel.UID.CompanyKey = user.CompanyKey;
        orderRequestModel.UID.EnvironmentName = user.EnvironmentName;
        orderRequestModel.UID.IsUrbanPiper = user.IsUrbanPiper;

        orderRequestModel.POSStatusKey = selectedNavItem.POSStatusKey;
        //orderRequestModel.POSStatusKey = selectedNavItem.POSStatusKey ?? 1;
        orderRequestModel.OrderDate = moment();

        //if (orderRequestModel.POSStatusKey > 1) {
        const response = await apis.Orders.fetchOrderCountByOrderStatus(
          orderRequestModel
        );

        if (response.ResponseType === APIResponseType.Success) {
          setCount(response.TotalRecordCount);
        } else {
          // console.log("api fetching error");
        }
        //}
      } catch (e) {
        //notifyError();
        // console.log(e);
      }
    };

    fetchOrderCountData();
  }, []);

  //handle Pagination
  const handlePageChange = useCallback(
    (event: React.ChangeEvent<unknown>, value: number) => {
      setPage(value);

      setIsDataTableLoading(true);
      orderListRequestModel.UID.UserKey = user.UserKey;
      orderListRequestModel.UID.LocationKey = user.LocationKey;
      orderListRequestModel.UID.CompanyKey = user.CompanyKey;
      orderListRequestModel.UID.EnvironmentName = user.EnvironmentName;
      orderListRequestModel.OrderDate = filteredDateValue ?? moment();
      orderListRequestModel.POSStatusKey = selectedNavItem.POSStatusKey;

      orderListRequestModel.PageNo = value;

      //console.log("oedr", orderListRequestModel);

      const ac = new AbortController();

      apis.Orders.fetchPartnerOrderList(orderListRequestModel)
        .then((response) => {
          if (response.ResponseType === APIResponseType.Success) {
            setPaginatedOrderList(response.ResponseData.AllOrders);
            setIsDataTableLoading(false);
          } else {
            console.log("api fetching error");
            setIsDataTableLoading(false);
          }
        })
        .catch((e) => {
          //notifyError();
          //  console.log(e);
          setIsDataTableLoading(false);
        });

      return () => ac.abort();
    },
    [paginatedOrderList]
  );

  const handleCheckAll = (e: any) => {
    const { checked } = e.target;

    if (checked) {
      //setIsAllSelected(true);
      const newOrder = orders.filter(
        (order: IPartnerOrder) =>
          order.OrderDelivery.OrderStatus.POSStatusKey ===
          selectedNavItem.POSStatusKey
      );
      setSelectedOrder(newOrder);
      newOrder.map(
        (order: IPartnerOrder) => {
          //  console.log(order.OrderReference);
          // setSelectedID([...selectedID, order.OrderReference]);
          selectedID.push(order.PartnerOrderId);
        }
        //setSelectedID([...selectedID, order.OrderReference])
      );
      setSelectedID([...selectedID]);
      // const newID = newOrder.filter(
      //   (order: IPartnerOrder) => order.OrderReference
      // );
      //setSelectedID(newID);

      //console.log(newOrder);
    } else {
      // setIsAllSelected(false);
      setSelectedOrder([]);
      setSelectedID([]);
    }
  };

  const handleChange = (e: any, order: IPartnerOrder) => {
    const { checked } = e.target;

    if (checked) {
      const isExist = selectecOrder.find(
        (singleOrder) => singleOrder.PartnerOrderId === order.PartnerOrderId
      );
      if (!isExist) {
        setSelectedOrder([...selectecOrder, order]);
        setSelectedID([...selectedID, order.PartnerOrderId]);
      }
    } else {
      const newOrderList = selectecOrder.filter(
        (singleOrder: IPartnerOrder) => singleOrder.OrderId !== order.OrderId
      );
      setSelectedOrder(newOrderList);
      const filteredIDList = selectedID.filter(
        (id: number) => id !== order.PartnerOrderId
      );
      setSelectedID(filteredIDList);
      // setIsAllSelected(false);
      // setSelectedOrder((prev:IPartnerOrder[])=>prev.map((singleOrder:IPartnerOrder)=> singleOrder.OrderId !== order.OrderDelivery))
    }
  };

  const handleOrderCancel = async () => {
    setIsLoading(true);
    for (const order of selectecOrder) {
      const statusRequestModel: IPartnerOrderRequestModel = {
        PartnerOrderId: order.PartnerOrderId,
        OrderId: order.OrderId,
        POSStatusKey: 117201,
        OrderDate: undefined,
        OrderTypeKey: order.OrderDelivery.TypeOfOrder.OrderTypeId,
        DenyOrCancelReasonCode: "STORE_CLOSED",
        DenyOrCancelReasonKey: 1,
        CurrentPOSStatusCode: order.OrderDelivery.OrderStatus.POSStatusCode,
        OrderReference: "",
        RequestId: API_INTEGRATION_ID,
        IntegrationId: API_INTEGRATION_ID,
        ApiKey: "",
        UID: {
          CompanyKey: user?.CompanyKey ?? 0,
          LocationKey: user?.LocationKey ?? 0,
          UserKey: user?.UserKey ?? 0,
          EnvironmentName: user?.EnvironmentName ?? 0,
          IsUrbanPiper: user?.IsUrbanPiper ?? false,
        },
        RequestingUser: 0,
        RequestingId: "",
        Schema: "",
        ValidationMessages: [],
        IsApprovedStatus: 0,
        IsActive: 0,
      };
      //  console.log(statusForBtn[0].POSStatusCode);
      const response = await apis.Orders.updateOrderStatus(statusRequestModel);

      if (response.ResponseType === APIResponseType.Success) {
        //console.log(" success");
      }
    }

    setIsLoading(false);
  };

  const handleOrderComplete = async () => {
    // cancel 117201

    setIsLoading(true);
    for (const order of selectecOrder) {
      const statusRequestModel: IPartnerOrderRequestModel = {
        PartnerOrderId: order.PartnerOrderId,
        OrderId: order.OrderId,
        POSStatusKey: 117199,
        OrderDate: undefined,
        OrderTypeKey: order.OrderDelivery.TypeOfOrder.OrderTypeId,
        DenyOrCancelReasonCode: "",
        DenyOrCancelReasonKey: 0,
        CurrentPOSStatusCode: order.OrderDelivery.OrderStatus.POSStatusCode,
        OrderReference: "",
        RequestId: API_INTEGRATION_ID,
        IntegrationId: API_INTEGRATION_ID,
        ApiKey: "",
        UID: {
          CompanyKey: user?.CompanyKey ?? 0,
          LocationKey: user?.LocationKey ?? 0,
          UserKey: user?.UserKey ?? 0,
          EnvironmentName: user?.EnvironmentName ?? 0,
          IsUrbanPiper: user?.IsUrbanPiper ?? false,
        },
        RequestingUser: 0,
        RequestingId: "",
        Schema: "",
        ValidationMessages: [],
        IsApprovedStatus: 0,
        IsActive: 0,
      };
      //  console.log(statusForBtn[0].POSStatusCode);
      const response = await apis.Orders.updateOrderStatus(statusRequestModel);

      if (response.ResponseType === APIResponseType.Success) {
        //console.log(" success");
      }
    }

    setIsLoading(false);
    //console.log(" All completed");
    history.push("/orders");
    // window.location.reload();
  };

  const handleOrderReady = async () => {
    // cancel 117201

    setIsLoading(true);
    for (const order of selectecOrder) {
      const statusRequestModel: IPartnerOrderRequestModel = {
        PartnerOrderId: order.PartnerOrderId,
        OrderId: order.OrderId,
        POSStatusKey: 117195,
        OrderDate: undefined,
        OrderTypeKey: order.OrderDelivery.TypeOfOrder.OrderTypeId,
        DenyOrCancelReasonCode: "",
        DenyOrCancelReasonKey: 0,
        CurrentPOSStatusCode: order.OrderDelivery.OrderStatus.POSStatusCode,
        OrderReference: "",
        RequestId: API_INTEGRATION_ID,
        IntegrationId: API_INTEGRATION_ID,
        ApiKey: "",
        UID: {
          CompanyKey: user?.CompanyKey ?? 0,
          LocationKey: user?.LocationKey ?? 0,
          UserKey: user?.UserKey ?? 0,
          EnvironmentName: user?.EnvironmentName ?? 0,
          IsUrbanPiper: user?.IsUrbanPiper ?? false,
        },
        RequestingUser: 0,
        RequestingId: "",
        Schema: "",
        ValidationMessages: [],
        IsApprovedStatus: 0,
        IsActive: 0,
      };
      //  console.log(statusForBtn[0].POSStatusCode);
      const response = await apis.Orders.updateOrderStatus(statusRequestModel);

      if (response.ResponseType === APIResponseType.Success) {
        // console.log(" success");
      }
    }

    setIsLoading(false);
    //console.log(" All completed");
    history.push("/orders");
    // window.location.reload();
  };

  const handleOrderDispatch = async () => {
    // cancel 117201

    setIsLoading(true);
    for (const order of selectecOrder) {
      const statusRequestModel: IPartnerOrderRequestModel = {
        PartnerOrderId: order.PartnerOrderId,
        OrderId: order.OrderId,
        POSStatusKey: 117196,
        OrderDate: undefined,
        OrderTypeKey: order.OrderDelivery.TypeOfOrder.OrderTypeId,
        DenyOrCancelReasonCode: "",
        DenyOrCancelReasonKey: 0,
        CurrentPOSStatusCode: order.OrderDelivery.OrderStatus.POSStatusCode,
        OrderReference: "",
        RequestId: API_INTEGRATION_ID,
        IntegrationId: API_INTEGRATION_ID,
        ApiKey: "",
        UID: {
          CompanyKey: user?.CompanyKey ?? 0,
          LocationKey: user?.LocationKey ?? 0,
          UserKey: user?.UserKey ?? 0,
          EnvironmentName: user?.EnvironmentName ?? 0,
          IsUrbanPiper: user?.IsUrbanPiper ?? false,
        },
        RequestingUser: 0,
        RequestingId: "",
        Schema: "",
        ValidationMessages: [],
        IsApprovedStatus: 0,
        IsActive: 0,
      };
      //  console.log(statusForBtn[0].POSStatusCode);
      const response = await apis.Orders.updateOrderStatus(statusRequestModel);

      if (response.ResponseType === APIResponseType.Success) {
        // console.log(" success");
      }
    }

    setIsLoading(false);
    //console.log(" All completed");
    history.push("/orders");
    // window.location.reload();
  };

  if (isLoading === true) {
    return <LoadingComponent />;
  }
  return (
    <div>
      {/* <button>SAVE</button> */}
      {selectecOrder.length > 0 && (
        <>
          {selectedNavItem?.POSStatusCode === "Confirmed" && (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <Button variant="outlined" onClick={handleOrderComplete}>
                Complete order
              </Button>

              <Button variant="outlined" onClick={handleOrderComplete}>
                Cancel order
              </Button>

              <Button variant="outlined" onClick={handleOrderReady}>
                Ready
              </Button>

              <Button variant="outlined" onClick={handleOrderDispatch}>
                Dispatched
              </Button>
            </div>
          )}

          {selectedNavItem?.POSStatusCode === "Ready" && (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <Button variant="outlined" onClick={handleOrderComplete}>
                Complete order
              </Button>

              <Button variant="outlined" onClick={handleOrderComplete}>
                Cancel order
              </Button>

              <Button variant="outlined" onClick={handleOrderDispatch}>
                Dispatched
              </Button>
            </div>
          )}

          {selectedNavItem?.POSStatusCode === "Dispatched" && (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <Button variant="outlined" onClick={handleOrderComplete}>
                Complete order
              </Button>

              <Button variant="outlined" onClick={handleOrderComplete}>
                Cancel order
              </Button>
            </div>
          )}
        </>
      )}
      <Table size="sm" hover>
        <thead>
          <tr id={styles.table_head}>
            {(selectedNavItem?.POSStatusCode === "Ready" ||
              selectedNavItem?.POSStatusCode === "Confirmed" ||
              selectedNavItem?.POSStatusCode === "Dispatched") && (
              <td>
                <FormControlLabel
                  control={<Switch onChange={handleCheckAll} />}
                  label=""
                  //  checked={isAllSelected}
                />
              </td>
            )}
            <th>Order ID</th>
            <th>Location</th>
            <th className="text-center">Placed At</th>
            <th className="text-center">Quantity</th>
            <th className="text-center">Amount</th>
            <th className="text-center">Quick Actions</th>
          </tr>
        </thead>
        {/* {console.log("Selected Item :" + selectedItem)} */}
        <tbody>
          {isDataTableLoading && (
            <Spinner children="" type="grow" color="primary" />
          )}
          {!isDataTableLoading &&
            orders &&
            posOrderStatus &&
            selectedNavItem &&
            orders.map(
              (order: IPartnerOrder) =>
                order.OrderDelivery.OrderStatus.POSStatusKey ===
                  selectedNavItem.POSStatusKey && (
                  <tr
                    id={
                      selectedItem.OrderId === order.OrderId
                        ? styles.selected_row
                        : styles.row
                    }
                    key={order.PartnerOrderId}
                  >
                    {(selectedNavItem.POSStatusCode === "Ready" ||
                      selectedNavItem.POSStatusCode === "Confirmed" ||
                      selectedNavItem.POSStatusCode === "Dispatched") && (
                      <td>
                        <FormControlLabel
                          control={
                            <Switch
                              onChange={(e: any) => handleChange(e, order)}
                              checked={selectedID.includes(
                                order.PartnerOrderId
                              )}
                            />
                          }
                          label=""
                        />
                      </td>
                    )}

                    <td onClick={() => selectItem(order)}>
                      <div className={styles.order_id}>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            `/PartnerLogos/${order.OrderDelivery.TypeOfOrder.OrderTypeCode}.svg`
                          }
                          alt={`From ${order.OrderDelivery.TypeOfOrder.OrderTypeCode}`}
                          className={styles.brandLogo}
                        />
                        #{order.OrderReference}
                      </div>
                    </td>
                    <td onClick={() => selectItem(order)}>
                      {order.Customer.Address}
                    </td>
                    <td
                      className={styles.placed_at}
                      onClick={() => selectItem(order)}
                    >
                      {moment(order.OrderDate).format("DD-MM-YYYY, h:mm:ss a")}
                    </td>
                    <td
                      className={styles.order_quantity}
                      onClick={() => selectItem(order)}
                    >
                      {order.Quantity.toFixed(3)}
                    </td>
                    <td
                      className={styles.total_amount}
                      onClick={() => selectItem(order)}
                    >
                      {order.Amount.toFixed(2)}
                    </td>

                    <td className={styles.quick_actions}>
                      <PrintIcon
                        fontSize="medium"
                        onClick={() =>
                          handleBillPrinting(
                            order.PartnerOrderId,
                            order.OrderReference
                          )
                        }
                        className={styles.print_button}
                      />
                      {order &&
                        statusForBtn &&
                        !selectedNavItem.IsCompletedOrderStatus && (
                          /* selectedNavItem.POSStatusCode !== "Cancelled" &&  */ <OrderStatusUpdateButton
                            classNames={
                              !isTablet && window.innerWidth < 1440
                                ? "w-75"
                                : "w-52"
                            }
                            statusForBtn={statusForBtn}
                            selectedOrder={order}
                            updateOrder={updateOrder}
                            posOrderStatus={posOrderStatus}
                          />
                        )}
                    </td>
                  </tr>
                )
            )}
        </tbody>
      </Table>
      <PaginationComponent
        orderCount={count}
        page={page}
        handlePageChange={handlePageChange}
      />
    </div>
  );
};

export default DataTable;
